<template>
<router-view />
</template>

<script>
export default {
  name: 'StatisticalAnalysisPM',
  routeInfo: {
    label: '颗粒物组分分析'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/00PM/index.vue